var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNnybLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 154,
    height: 155,
    viewBox: "0 0 154 155",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M153.9 102.8H143.6V113.1H153.9V102.8Z",
    fill: "#1C355E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M143.7 92.5H133.4V102.8H143.7V92.5Z",
    fill: "#1C355E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M153.9 82.2002H143.6V92.5002H153.9V82.2002Z",
    fill: "#1C355E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M143.7 72H133.4V82.3H143.7V72Z",
    fill: "#1C355E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M153.9 61.7002H143.6V72.0002H153.9V61.7002Z",
    fill: "#1C355E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M143.7 51.5H133.4V61.8H143.7V51.5Z",
    fill: "#1C355E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M153.9 41.2002H143.6V51.5002H153.9V41.2002Z",
    fill: "#1C355E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M143.7 30.8999H133.4V41.1999H143.7V30.8999Z",
    fill: "#1C355E"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M153.9 20.7002H143.6V31.0002H153.9V20.7002Z",
    fill: "#1C355E"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M143.7 113H133.4V123.3H143.7V113Z",
    fill: "#1C355E"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M153.9 123.1H143.6V133.4H153.9V123.1Z",
    fill: "#1C355E"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M153.9 0H143.6V10.3H153.9V0Z",
    fill: "#1C355E"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M143.7 10.3999H133.4V20.6999H143.7V10.3999Z",
    fill: "#1C355E"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M133.4 0.200195H123.1V10.5002H133.4V0.200195Z",
    fill: "#1C355E"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M123.2 10.3999H112.9V20.6999H123.2V10.3999Z",
    fill: "#1C355E"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M112.9 0H102.6V10.3H112.9V0Z",
    fill: "#1C355E"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M102.601 10.3999H92.3008V20.6999H102.601V10.3999Z",
    fill: "#1C355E"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M92.3996 0.200195H82.0996V10.5002H92.3996V0.200195Z",
    fill: "#1C355E"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M82.1008 10.3999H71.8008V20.6999H82.1008V10.3999Z",
    fill: "#1C355E"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M71.8996 0.200195H61.5996V10.5002H71.8996V0.200195Z",
    fill: "#1C355E"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M61.6008 10.3999H51.3008V20.6999H61.6008V10.3999Z",
    fill: "#1C355E"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3 0.200195H41V10.5002H51.3V0.200195Z",
    fill: "#1C355E"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8 0.200195H20.5V10.5002H30.8V0.200195Z",
    fill: "#1C355E"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6008 10.3999H10.3008V20.6999H20.6008V10.3999Z",
    fill: "#1C355E"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3 0H0V10.3H10.3V0Z",
    fill: "#1C355E"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1008 10.3999H30.8008V20.6999H41.1008V10.3999Z",
    fill: "#1C355E"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3 61.3999H0V71.6999H10.3V61.3999Z",
    fill: "#1C355E"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6008 71.7002H10.3008V82.0002H20.6008V71.7002Z",
    fill: "#1C355E"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3 81.8999H0V92.1999H10.3V81.8999Z",
    fill: "#1C355E"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6008 92.2002H10.3008V102.5H20.6008V92.2002Z",
    fill: "#1C355E"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3 102.5H0V112.8H10.3V102.5Z",
    fill: "#1C355E"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6008 112.7H10.3008V123H20.6008V112.7Z",
    fill: "#1C355E"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3 123H0V133.3H10.3V123Z",
    fill: "#1C355E"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6008 51.2002H10.3008V61.5002H20.6008V51.2002Z",
    fill: "#1C355E"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3 20.5H0V30.8H10.3V20.5Z",
    fill: "#1C355E"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6008 30.7998H10.3008V41.0998H20.6008V30.7998Z",
    fill: "#1C355E"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3 41H0V51.3H10.3V41Z",
    fill: "#1C355E"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3 143.7H41V154H51.3V143.7Z",
    fill: "#1C355E"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1008 133.4H30.8008V143.7H41.1008V133.4Z",
    fill: "#1C355E"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8 143.7H20.5V154H30.8V143.7Z",
    fill: "#1C355E"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6008 133.4H10.3008V143.7H20.6008V133.4Z",
    fill: "#1C355E"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3 143.7H0V154H10.3V143.7Z",
    fill: "#1C355E"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M71.8996 143.7H61.5996V154H71.8996V143.7Z",
    fill: "#1C355E"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M82.1008 133.4H71.8008V143.7H82.1008V133.4Z",
    fill: "#1C355E"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M92.3996 143.7H82.0996V154H92.3996V143.7Z",
    fill: "#1C355E"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M102.601 133.4H92.3008V143.7H102.601V133.4Z",
    fill: "#1C355E"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M112.9 143.8H102.6V154.1H112.9V143.8Z",
    fill: "#1C355E"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M123.2 133.4H112.9V143.7H123.2V133.4Z",
    fill: "#1C355E"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M133.4 143.7H123.1V154H133.4V143.7Z",
    fill: "#1C355E"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M143.7 133.4H133.4V143.7H143.7V133.4Z",
    fill: "#1C355E"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M153.9 143.7H143.6V154H153.9V143.7Z",
    fill: "#1C355E"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M61.6008 133.4H51.3008V143.7H61.6008V133.4Z",
    fill: "#1C355E"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M85.9008 101.8H90.5008H96.4008H101.101L96.4008 97.0998V56.9998L101.101 52.2998H100.401H96.4008H95.8008H91.2008H90.5008H86.4008H85.9008L90.5008 56.9998V81.7998L61.1008 52.2998H52.8008L57.5008 56.9998V97.0998L56.6008 97.9998L52.8008 101.8H57.5008H63.4008H68.0008L63.4008 97.0998V68.3998L90.5008 95.4998V97.0998L85.9008 101.8Z",
    fill: "#1C355E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNnybLogo);
export default __webpack_public_path__ + "static/media/nnyb_logo.ddd28bbc19c8bcac4445445adbe80df2.svg";
export { ForwardRef as ReactComponent };